import { fabric } from 'fabric';
import DEFINE from '../define';
import ToolBase from '../basic';
import protractor from '../../../assets/art/math_tool/protractor.svg'
import { focusStore } from '../../store/nowFocusStore';
import CustomControls from '../custom_controls/custom_controls';

export default class Protractor extends ToolBase {

    name = DEFINE.TOOLS.PROTRACTOR;

    originPosition = new fabric.Point(0, 0);
    scale = 0.5;

    // 量角器
    protractor = null;

    customControl = new CustomControls();

    constructor(parent) {
        super(parent);
    }

    async create() {
        super.create();

        const self = this;
        this.originPosition.x = focusStore.mainBookPage.pagePercentPoint.x * this.parent.canvas.width;
        this.originPosition.y = focusStore.mainBookPage.pagePercentPoint.y * this.parent.canvas.height;

        // 限制只能生成一個
        this.canvas.getObjects().forEach(object => {
            if (object && (object.tag || "").includes(DEFINE.TAG.PROTRACTOR)) {
                self.canvas.remove(object);
            }
        });

        const protractorSvg = await this.loadSvgToGroup(protractor);
        protractorSvg.set({
            top: 0,
            left: 0,
            scaleX: self.scale,
            scaleY: self.scale,
            originX: "center",
            originY: "center",
        });

        const rectangle = new fabric.Rect({
            top: 0,
            left: 0,
            width: protractorSvg.getScaledWidth() * 1.5,
            height: protractorSvg.getScaledHeight() * 2,
            originX: "center",
            originY: "center",
            fill: "#303030",
            visible: false
        });

        this.protractor = new fabric.Group([rectangle, protractorSvg], {
            tag: DEFINE.TAG.PROTRACTOR + new Date().getTime(),
            toolType: self.name,
            left: self.originPosition.x,
            top: self.originPosition.y,
            angle: 0,
            hasBorders: false,
            hasControls: false,
            selectable: true,
            perPixelTargetFind: true,
            selectionActive: true,
            originX: "center",
            originY: "center",
            subTargetCheck: true,  
            lockScalingFlip: true,
        });

        this.canvas.add(this.protractor);

        this.customControl.init("br", this.protractor, this.protractor._objects[1]);
        this.canvas.renderAll();
        this.protractor.setCoords();

        this.registerEvent(group);
    }

    recover(object) {
        let tag = object.tag;

        if (tag.includes(DEFINE.TAG.PROTRACTOR)) {
            this.protractor = object;
        }
    }

    mouseDown(o) {
        this.canvas._activeObject = o.target;
        this.customControl.switchControl(true);
        this.customControl.mousedown(o, DEFINE.TAG.PROTRACTOR);
    }

    mouseMove(o) {
        this.customControl.mousemove(o, DEFINE.TAG.PROTRACTOR);
    }

    mouseUp(o) {
        this.parent.changeTool(null);
        this.customControl.mouseup(o, DEFINE.TAG.PROTRACTOR);
    }

    registerEvent(group) {
        group.on("deselected", (e) => {
            this.customControl.switchControl(false);
        })
    }
}